import {Box, Link, Divider} from "@mui/material";
import {AUTH_MODES, type AuthMode} from "auth/types";
import type {FC} from "react";

type AuthFormFooterProps = {
  mode: AuthMode;
  onSwitch: (m: AuthMode) => void;
};

const AuthFormFooter: FC<AuthFormFooterProps> = ({mode, onSwitch}) => (
  <Box
    mt={2}
    textAlign="center"
    sx={{display: "flex", flexDirection: "column", gap: 1}}>
    {mode === AUTH_MODES.LOGIN ? (
      <>
        <Link
          component="button"
          type="button"
          onClick={() => onSwitch(AUTH_MODES.SIGNUP)}>
          Don't have an account? Sign up
        </Link>

        <Divider sx={{my: 1}} />

        <Link
          component="button"
          type="button"
          onClick={() => onSwitch(AUTH_MODES.RESET)}>
          Forgot Password?
        </Link>
      </>
    ) : (
      <Link
        component="button"
        type="button"
        onClick={() => onSwitch(AUTH_MODES.LOGIN)}>
        Back to Sign In
      </Link>
    )}
  </Box>
);

export default AuthFormFooter;
